import { Progress } from "@chakra-ui/react";

import Setup from "../../../components/candidate/signupFlow/setup";
import { getisProfile30percent } from "../../../utils/helper";

const SetupPage = () => {
  const profilePercentage = getisProfile30percent();
  return (
    <>
      <Progress
        colorScheme="progressBar"
        size="xs"
        value={profilePercentage}
        w="full"
        borderRadius={"lg"}
        mb="6 !important"
        mt="2 !important"
      />
      <Setup />
    </>
  );
};

export default SetupPage;
